<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Third Party App Developers
            </v-card-title>

            <v-dialog v-model="dialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
                <invalidate-password-form :value="userId" @cancel="dialog = false" @save="onInvalidation" />
            </v-dialog>

            <v-container fluid>
                <table-base :filter="roleFilter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :table-form="thirdPartyAppDeveloperForm" :refresh-key="refreshKey" :set-api-data="setApiData">
                    <template v-slot:tabs>
                        <v-row>
                            <v-col>
                                <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                                    <v-btn @click="toggleTabs(false)"> Active </v-btn>
                                    <v-btn @click="toggleTabs(true)"> Inactive </v-btn>
                                </v-btn-toggle>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:buttons="{ item }">
                        <v-btn @click="resendEmail(item.id)"><v-icon>mdi-email</v-icon></v-btn>
                        <v-btn v-if="!displayInactive" @click="invalidatePassword(item.id)"><v-icon>mdi-key-remove</v-icon></v-btn>
                    </template>
                </table-base>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        props: [
            'filter'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
            invalidatePasswordForm: () => import('@/forms/InvalidatePasswordForm')
        },
        data() {
            return {
                thirdPartyAppDeveloperForm: () => import('../forms/ThirdPartyAppDeveloperForm'),
                headers: [
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: 'RoleId', value: 'roleId' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    "emailAddress"
                ],
                itemsField: 'thirdPartyAppDevelopers',
                apiMethod: 'ThirdPartyAppDevelopers',
                claimName: 'ThirdPartyAppDevelopers',
                formTitle: 'Third Party App Developer',
                excelTitle: 'Third Party App Developers',
                hasEditPage: false,
                role: null,
                userId: null,
                dialog: false,
                refreshKey: 0,
                displayInactive: false
            }
        },
        async mounted() {
            var response = await axios.get('api/Roles');
            this.role = response.data.items.find(i => i.name === "Third Party App Developer");
        },
        methods: {
            async resendEmail(userId) {
                await axios.get("/api/Users/ResendEmail/" + userId);
            },
            async invalidatePassword(id) {
                this.userId = id;
                this.dialog = true;
            },
            onInvalidation() {
                this.dialog = false;
                this.refreshKey++;
            },
            async toggleTabs(displayInactive) {
                this.displayInactive = displayInactive;
                this.refreshKey += 1;
            },
            setApiData(data) {
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayInactive ? i.isInactive : !i.isInactive));
            }
        },
        computed: {
            roleFilter() {
                if (this.role !== null && typeof this.role !== "undefined") {
                    var roleId = this.role.id;
                    var filter = { ...this.filter, roleId, isInactive: false };
                    return filter;
                }
                else {
                    return { ...this.filter, isInactive: false };
                }
            }
        }
    };
</script>
